import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import UserService from 'services/usersService';
import { formatValidationErrors } from 'utils/ArrayUtils';

export const initialState = {
    list : [],
    fetching: false,
    creating: false,
    updating : false,
    deleting : false,
    errorMessages: [],
    showMessage: false,
    showEditForm : false,
    showNewForm : false,
}

export const fetchUsers = createAsyncThunk('/fetchUsers', async (data, {rejectWithValue }) => {
    try {
            const response = await UserService.fetch();
            var code = response.code;	
            return {
                code: code,
                users : response.data
            };
    } catch (err) {
        let code = err.response?.data.code;
        let response = err.response;
        return rejectWithValue({
            code: code,
            errorMessages: response?.data?.message || 'Error'
        });
    }
});

export const createUser = createAsyncThunk('/createUser',async (data, { rejectWithValue }) => {
    try {
        const response = await UserService.create(data)
        const code  = response.original.code;
        return {
            code: code,
            users : response.original.data
        };
    } catch (err) {
        return rejectWithValue({code : err.response.status, error : err.response?.data.errors} || {error : "Error creating a user"})
    }
})

export const updateUser = createAsyncThunk('/updateUser',async (data, { rejectWithValue }) => {
    try {
        const response = await UserService.update(data)
        const code = response.original.code;
        return {
            code: code,
            users : response.original.data
        };
    } catch (err) {
        return rejectWithValue({code : err.response.status, error : err.response?.data.errors} || {error : "Error creating a user"})
    }
})

export const deleteUser = createAsyncThunk('/deleteUser',async (id, { rejectWithValue }) => {
    try {
        const response = await UserService.delete(id)
        const code = response.original.code;
        return {
            code: code,
            users : response.original.data
        };
    } catch (err) {
        return rejectWithValue({error : "Error deleting a user"})
    }
})

export const usersSlice = createSlice({
    name: 'users',
    initialState,
    reducers: {
        showLoading: (state) => {
            state.fetching = !state.fetching
        },
        toggleUserEditForm : (state) => {
            state.showEditForm =  !state.showEditForm;
        },
        toggleUserNewForm : (state) => {
            state.showNewForm  = !state.showNewForm        
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchUsers.pending, (state) => {
                state.fetching = true
            })
            .addCase(fetchUsers.fulfilled, (state, action) => {
                state.fetching = false
                state.list = action.payload.users
            })
            .addCase(fetchUsers.rejected, (state, action) => {
                state.fetching = false
            })
            .addCase(createUser.pending, (state) => {
                state.creating = true
            })
            .addCase(createUser.fulfilled, (state, action) => {
                state.creating = false
                state.list = action.payload.users
                state.showNewForm = !state.showNewForm;
            })
            .addCase(createUser.rejected, (state, action) => {
                if(action.payload.code == 422){
                    state.errorMessages = formatValidationErrors(action.payload.error)
                }
                else {
                    // state.errorMessages = action.payload.error;
                }
                state.creating = false;
            })
            .addCase(updateUser.pending, (state, action) => {
                state.updating = true
            })
            .addCase(updateUser.fulfilled, (state, action) => {
                state.updating = false
                state.list = action.payload.users
                state.showEditForm = !state.showEditForm
            })
            .addCase(updateUser.rejected, (state, action) => {
                if(action.payload.code == 422){
                    state.errorMessages = formatValidationErrors(action.payload.error)
                }
                else {
                    state.errorMessages = action.payload.error;
                }
                state.updating = false
            })
            .addCase(deleteUser.pending, (state, action) => {
                state.deleting = true
            })
            .addCase(deleteUser.fulfilled, (state, action) => {
                state.deleting = false
                state.list = action.payload.users
            })
            .addCase(deleteUser.rejected, (state, action) => {
                state.deleting = false
            })
    },
})

export const { 
    showLoading,
    toggleUserEditForm,
    toggleUserNewForm
} = usersSlice.actions

export default usersSlice.reducer